
import IntlTelInputBox from "../../component/login/IntlTelInputBox";
import React from "react";
import { Modal, Form, Button, Row, Col } from "react-bootstrap";
import { Typeahead } from "react-bootstrap-typeahead";
const EditAddressModal = ({
  show,
  handleClose,
  handleUpdateAddress,
  validated,
  currentAdd,
  changeHandle,
  fullPhone,
  setFullPhone,
  handleIntel,
  handleCountryChange,
  handleStateChange,
  allCountry,
  typehCountry,
  setTypehCountry,
  currentState,
  typehState,
  setTypehState,
  isUpdating = false,
}) => {
  return (
    <Modal
      show={show}
      onHide={handleClose}
      className="address-popup"
    >
      <Form
        noValidate
        validated={validated}
        onSubmit={handleUpdateAddress}
        className="edit-address-form"
      >
        <Modal.Header closeButton>
          <Modal.Title>Edit Address</Modal.Title>
        </Modal.Header>

        <Modal.Body className="custom-add">
          <div className="address-form-wrap">
            <Form.Group className="mb-3 custom-50">
              <Form.Control
                type="text"
                name="contact_person_name"
                placeholder="Contact person name"
                value={currentAdd?.contact_person_name || ""}
                onChange={changeHandle}
                autoFocus
                required
              />
            </Form.Group>

            <Form.Group className="mb-3 ph-country custom-50">
              <div className="login-data mobile-field">
                <IntlTelInputBox
                  setFullPhone={setFullPhone}
                  selectedPhone={fullPhone}
                  handleIntel={handleIntel}
                />
              </div>
            </Form.Group>

            <Form.Group className="mb-3 custom-50">
              <Form.Control
                type="text"
                name="address_type"
                placeholder="Address type"
                value={currentAdd?.address_type || ""}
                onChange={changeHandle}
                required
              />
            </Form.Group>

            <Form.Group className="mb-3 custom-50">
              <Typeahead
                id="edit-address-country"
                labelKey={(option) => option}
                onChange={handleCountryChange}
                options={allCountry || []}
                placeholder="Choose a country..."
                selected={typehCountry || []}
                emptyLabel="No countries found"
              />
            </Form.Group>

            <Form.Group className="mb-3 custom-50">
              <Typeahead
                id="edit-address-state"
                labelKey="name"
                onChange={handleStateChange}
                options={currentState || []}
                placeholder="Choose a state..."
                selected={typehState || []}
              />
            </Form.Group>

            <Form.Group className="mb-3 custom-50">
              <Form.Control
                type="text"
                name="city"
                placeholder="City"
                value={currentAdd?.city || ""}
                onChange={changeHandle}
                required
              />
            </Form.Group>

            <Form.Group className="mb-3 custom-50">
              <Form.Control
                type="text"
                name="zip"
                placeholder="Zipcode"
                value={currentAdd?.zip || ""}
                onChange={changeHandle}
                required
              />
            </Form.Group>

            <Form.Group className="mb-3 custom-50">
              <Form.Control
                type="text"
                name="landmark"
                placeholder="Landmark"
                value={currentAdd?.landmark || ""}
                onChange={changeHandle}
              />
            </Form.Group>

            <Form.Group className="mb-3 custom-100">
              <Form.Control
                as="textarea"
                name="address"
                placeholder="Address"
                rows={3}
                value={currentAdd?.address || ""}
                onChange={changeHandle}
                required
              />
            </Form.Group>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="secondary"
            type="button"
            onClick={handleClose}
          >
            Cancel
          </Button>

          <Button
            variant="primary"
            type="submit"
            disabled={!currentAdd || isUpdating}
          >
            {isUpdating ? "Saving..." : "Save Changes"}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>

  );
};
export default EditAddressModal;